import React from "react";
import HomePage from "../../../HomePage";
import "./index.css";
import loginIllustration from "../../../../Assets/login.png";
import image from "../../../../Assets/signupImage.png";
import icon from "../../../../Assets/icon_white.png";
import choose_lang from "../../../../Assets/choose_lang.png";
import ConsentSteps from "./consentSteps";
import SignUpPage from "../../../HomePage/signUp";

interface ISidePanelProps {
  className?: string;
  type: string;
}

const LoginSignupSidePanel: React.FC<ISidePanelProps> = ({
  className,
  type,
}) => {
  return (
    <div className={`${className || ""} typoGraphySection`}>
      {type === "login" ? (
        <HomePage />
      ) : type === "webview" ? (
        <HomePage />
        // <div className="homePageWebview">
        //   <HomePage />
        //   <ConsentSteps />
        // </div>
      ) : (
        <div className="homePageRoot homePageSecondaryBackground">
          {type === "signup" ? (
            <SignUpPage />
          ) : type === "linkAccount" ? (
            <img className="width40" src={icon} alt="INK" />
          ) : type === "languageSelection" ? (
            <img
              className="width50"
              src={choose_lang}
              alt="Choose Language"
            />
          ) : (
            <></>
          )}
        </div>
      )}
    </div>
  );
};

export default LoginSignupSidePanel;